import { render, staticRenderFns } from "./menuCategory.vue?vue&type=template&id=802690c8"
import script from "./menuCategory.vue?vue&type=script&lang=js"
export * from "./menuCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports